/**
 * Ryan O'Dowd
 * 2023-09-09
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const PracticeAndReviewIndicator = (props: PracticeAndReviewIndicatorProps) => {
  const i18n = hooks.useI18n();
  const styles = hooks.useStyles(getStyles);

  let letter = ' ';
  let legendKey = 'Unselected';
  let statusStyles = styles.inactiveInnerContainer;
  if (props.status === 'active') {
    letter = i18n('pForPractice');
    legendKey = i18n('practice');
    statusStyles = styles.activeInnerContainer;
  } else if (props.status === 'review') {
    letter = i18n('rForReview');
    legendKey = i18n('review');
    statusStyles = styles.reviewInnerContainer;
  } else if (props.status === 'indeterminate') {
    letter = '-';
    legendKey = i18n('indeterminate');
    statusStyles = styles.indeterminateInnerContainer;
  } else if (props.status === 'disabled') {
    legendKey = i18n('disabled');
    statusStyles = styles.disabledInnerContainer;
  }

  return (
    <View style={styles.container}>
      <View style={[styles.innerContainer, statusStyles]}>
        <Text style={[styles.letterText, props.status === 'disabled' && styles.disabledLetterText]}>{letter}</Text>
      </View>
      {props.showLegend && <Text style={[styles.legendText, props.legendTextColor && {color: props.legendTextColor}]}>{legendKey}</Text>}{/* @TODO: i18n */}
    </View>
  );
};

class PracticeAndReviewIndicatorProps {
  status: 'active' | 'review' | 'inactive' | 'indeterminate' | 'disabled';

  showLegend?: boolean;
  legendTextColor?: string;
};

export default PracticeAndReviewIndicator;
